import { render, staticRenderFns } from "./ForeignCitationCard.vue?vue&type=template&id=562e0e68&scoped=true"
import script from "./ForeignCitationCard.vue?vue&type=script&lang=js"
export * from "./ForeignCitationCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "562e0e68",
  null
  
)

export default component.exports